import { DocumentTempSaveRequest } from "apis/data-contracts";
import { TempDocumentDetailResponseWithAny } from "../hooks/queries/useTempDocumentDetailQuery";
import { DocumentForm } from "./getTempSaveRequest";

interface GetTempUpdateRequestProps<T> {
  tempDocumentDetail: TempDocumentDetailResponseWithAny;
  companyUuid?: string;
  form: T;
  tagUuids?: string[];
  freeTagUuids: string[];
  provinceName?: string;
  cityName?: string;
  lastLevel?: number;
  link?: string;
}

function getTempUpdateRequest<T extends DocumentForm>({
  tempDocumentDetail,
  tagUuids = [],
  companyUuid,
  form,
  freeTagUuids,
  provinceName,
  cityName,
  lastLevel,
  link,
}: GetTempUpdateRequestProps<T>) {
  const { attachmentFiles, decisionManager, referenceMember, ...documentData } =
    form;

  const updateRequest: DocumentTempSaveRequest = {
    name: form.title || tempDocumentDetail.name,
    documentClassUuid: tempDocumentDetail.documentClassUuid,
    cityName: cityName || tempDocumentDetail.cityName,
    provinceName: provinceName || tempDocumentDetail.provinceName,
    companyUuid,
    documentData: {
      ...tempDocumentDetail.documentData,
      ...documentData,
    },
    documentFileUrl: tempDocumentDetail.documentFileUrl,
    tagUuids,
    freeTagUuids,
    documentAttachmentFileList: attachmentFiles,
    lastLevel,
    link,
  };

  return updateRequest;
}

export default getTempUpdateRequest;
